import MaterialSymbolsQrCode from "@iconify-solid/material-symbols/qr-code";

export interface NavProps {
    onClickQrCode?: () => void;
    onClickLink?: (link: string) => void;
}

export default function Navbar(props: NavProps) {
    return <div class="flex flex-row grow-0 text-xl px-5 py-3 justify-between items-center text-purple-500 bg-zinc-900 w-full select-none">
        <div class="flex items-center gap-4">
            <div>TapSafe</div>
            <div>
                <a href="#" class="hover:underline" onClick={() => props.onClickLink?.('home')}>Home</a>
            </div>
            <div>
                <a href="#" class="hover:underline" onClick={() => props.onClickLink?.('bookkeeper')}>Book Keeper</a>
            </div>
        </div>
        <MaterialSymbolsQrCode class="w-6 h-6 text-white" on:click={props?.onClickQrCode} />
    </div>
}
